import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { cartProduct, normalizeCart, quantityValue, cartTotals, lineKey } from "@/lib/cart";
const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return normalizeCart(JSON.parse(localStorage.getItem("lenis_cart") || "[]")); }
    catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);
  const [purchaseType, setPurchaseType] = useState("one-time");
  const [previewOrder, setPreviewOrder] = useState(null);
  useEffect(() => {
    try { localStorage.setItem("lenis_cart", JSON.stringify(items)); } catch { /* Memory cart remains usable. */ }
  }, [items]);
  const addItem = (product, flavor, quantity = 1) => {
    const canonical = cartProduct(product?.id);
    const qty = quantityValue(quantity);
    if (!canonical) { toast.info("This product is not available to add to your bag."); return; }
    if (!qty) return;
    setPreviewOrder(null);
    setItems(previous => normalizeCart([...previous, { ...canonical, quantity: qty }]));
    setIsOpen(true);
  };
  const removeItem = (id, flavor) => setItems(previous => previous.filter(i => lineKey(i.id, i.flavor) !== lineKey(id, flavor)));
  const updateQty = (id, flavor, quantity) => {
    const qty = quantityValue(quantity);
    if (!qty) { removeItem(id, flavor); return; }
    setItems(previous => previous.map(i => lineKey(i.id, i.flavor) === lineKey(id, flavor) ? { ...i, quantity: qty } : i));
  };
  const count = useMemo(() => items.reduce((sum, i) => sum + i.quantity, 0), [items]);
  const totals = useMemo(() => cartTotals(items, purchaseType), [items, purchaseType]);
  const completePreviewOrder = () => {
    if (!items.length) return false;
    setPreviewOrder({ items: items.map(i => ({ ...i })), ...totals, purchaseType });
    setItems([]); setIsOpen(false);
    return true;
  };
  return <CartContext.Provider value={{ items, isOpen, setIsOpen, addItem, updateQty, removeItem,
    clearCart: () => setItems([]), count, ...totals, purchaseType,
    setPurchaseType: value => setPurchaseType(value === "subscribe" ? "subscribe" : "one-time"),
    previewOrder, completePreviewOrder }}>{children}</CartContext.Provider>;
}


